export default __webpack_public_path__ + "static/media/ear-Right.97ab1662.svg";